import { render, staticRenderFns } from "./CollectivityIntroSitecore.vue?vue&type=template&id=3cdd98ab"
import script from "./CollectivityIntroSitecore.vue?vue&type=script&lang=js"
export * from "./CollectivityIntroSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports